import React from 'react';

const SvgJp = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="JP_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="JP_svg__b">
        <stop stopColor="#D81441" offset="0%" />
        <stop stopColor="#BB0831" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="JP_svg__c" fill="#fff">
        <use xlinkHref="#JP_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <circle
        fill="url(#JP_svg__b)"
        mask="url(#JP_svg__c)"
        cx={14}
        cy={10}
        r={6}
      />
    </g>
  </svg>
);

export default SvgJp;
